import * as React from 'react';
const Maximize2 = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-maximize-2", ...props },
    React.createElement("polyline", { points: "15 3 21 3 21 9" }),
    React.createElement("polyline", { points: "9 21 3 21 3 15" }),
    React.createElement("line", { x1: "21", y1: "3", x2: "14", y2: "10" }),
    React.createElement("line", { x1: "3", y1: "21", x2: "10", y2: "14" })));
export default Maximize2;
//# sourceMappingURL=Maximize2.js.map